var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isNew)?_c('v-chip',{staticClass:"ma-2",attrs:{"text-color":"white","color":"red"}},[_vm._v(" Novo ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }